<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="订单号">
        <el-input
          v-model="formInline.orderid"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户名">
        <el-input
          v-model="formInline.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          v-model="formInline.user_mobile"
          placeholder="请输入用户手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="起止时间">
        <el-date-picker
          v-model="formInline.date"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="id" width="60"> </el-table-column>
      <el-table-column label="订单号" width="240">
        <template slot-scope="scope">
          <router-link
            class="link-div"
            tag="div"
            :to="{ name: 'order', query: { orderid: scope.row.orderid } }"
            >{{ scope.row.orderid }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="username" label="用户名" width="280">
        <template slot-scope="scope">
          <div v-html="scope.row.username"></div>
        </template>
      </el-table-column>
      <el-table-column prop="userMobile" label="手机号" width="180">
      </el-table-column>
      <el-table-column prop="content" label="评论内容"> </el-table-column>

      <el-table-column label="创建时间" width="160">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="reply(scope.row)">回复</el-button>
          <el-button type="text" @click="deleteComment(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    >
    </el-pagination>
    <replyDialog
      v-if="isDialogShow"
      @closeForm="closeForm"
      @onSubmit="onSubmit"
      :comment="comment"
    />
  </div>
</template>

<script>
import replyDialog from "./components/replyDialog";
//import { mapGetters } from "vuex";
export default {
  components: {
    replyDialog
  },
  data() {
    return {
      formInline: {
        orderid: "",
        username: "",
        user_mobile: "",
        date: ""
      },
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      comment: null,
      isDialogShow: false
    };
  },
  mounted() {
    this.onSubmit();
  },

  methods: {
    onSubmit() {
      let queryModel = {
        orderid: this.formInline.orderid,
        username: this.formInline.username,
        userMobile: this.formInline.user_mobile,
        createtimeFrom: Array.isArray(this.formInline.date)
          ? this.$ToDateString(this.formInline.date[0])
          : null,
        createtimeTo: Array.isArray(this.formInline.date)
          ? this.$ToDateString(this.formInline.date[1])
          : null,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        orderField: "id",
        orderSequence: "DESC"
      };
      this.$axios(this.$urlMapping["查询评论"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    onAdd() {},
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    closeForm() {
      this.isDialogShow = false;
    },
    reply(comment) {
      this.comment = comment;
      this.isDialogShow = true;
    },
    deleteComment(comment) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let ids = [comment.id];
        this.$axios(this.$urlMapping["删除评论"], {
          data: {
            ids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(() => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    }

    // checkUnread(id) {
    //   console.log(id); // 每一行的索引
    //   let ids = localStorage.getItem("unreadcommentids");
    //   return ids.indexOf(id) > -1;
    // },

    // tableRowClassName({ row, rowIndex }) {
    //   console.log(rowIndex); // 每一行的索引
    //   console.log(row); // 每一行的索引
    //   let ids = localStorage.getItem("unreadcommentids");
    //   if (ids.indexOf(row.id) > -1) {
    //     return "warning-row";
    //   }
    //   return "";
    // },
  }
};
</script>

<style lang="less">
// .warning-row {
//   background-color: #99ccff !important;
// }
</style>
